let _ = require('lodash');
let { monkey } = require('baobab');
const COMPONENTS = require('../../compositions/account');

module.exports = {
    /**
     * Устанавливаем элементы навигации с учетом состояния
     * @param {Object} state
     */
    subnavigationElements (state) {
        const TABS = [
            {
                title: 'Заказы',
                href: '/manager/orders',
                subPage: 'orders'
            },
            {
                title: 'Пользователи',
                href: '/manager/users',
                subPage: 'users'
            }
        ];

        state.set(['subnavigation', 'elements'], monkey([
            ['page', 'sub'],
            (subPage) => _.map(TABS, (tab) => Object.assign(
                {
                    isSelected: tab.subPage === subPage,
                    isClickable: tab.subPage !== subPage
                },
                tab
            ))
        ]));
    },

    /**
     * Устанавливаем компоненты для выбранной вкладке в разделе Личный кабинет
     * @param {Object} state
     */
    contentComponents (state) {
        state.set(['account', 'components'], monkey([
            ['page', 'sub'],
            ['user', 'role'],
            (subPage, role) => [_.find(COMPONENTS[role], { name: subPage })]
        ]));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/account/index.js